export const Engagement = []
export const Convert = []
export const System = []
export const Capture = []

export const LeadManagement = [
  {
    to: '/inbox',
    icon: '/media/icons/duotune/navigationicon/messages.svg',
    title: 'Inbox',
    Permissions: 'show-inbox',
  },
  {
    to: '/contact-collection',
    icon: '/media/icons/duotune/navigationicon/phone_book.svg',
    fontIcon: '/media/icons/duotune/navigationicon/phone_book.svg',
    title: 'Lead Management',
    Permissions: 'all',
  },
]

export const Campaign = [
  ////////////////////////////////FRONTEND USER//////////////////////////////////////////////
  {
    to: '/marketing',
    icon: '/media/icons/duotune/navigationicon/communication.svg',
    title: 'Marketing',
    Permissions: 'all',
    subMenu: [
      {
        to: '/new-message',
        // icon: '/media/icons/duotune/navigationicon/bulkmsg.svg',
        // fontIcon: '/media/icons/duotune/navigationicon/bulkmsg.svg',
        title: 'Send Campaign',
        parent: 'Marketing',
        Permissions: 'send-quick-sms',
        subMenu: [
          {
            to: '/new-message',
            title: 'SMS & MMS',
            parent: 'Send Campaign',
            Permissions: 'send-quick-sms',
          },
          {
            to: '#',
            title: 'Email',
            parent: 'Send Campaign',
            Permissions: 'send-quick-sms',
          },
        ],
      },
      {
        to: '/automation',
        // icon: '/media/icons/duotune/navigationicon/data.svg',
        // fontIcon: '/media/icons/duotune/navigationicon/data.svg',
        title: 'Flow and Automation',
        Permissions: 'all',
      },
      {
        to: '/reports',
        // icon: '/media/icons/duotune/graphs/gra007.svg',
        // fontIcon: '/media/icons/duotune/graphs/gra007.svg',
        title: 'Reports',
        Permissions: 'all',
        subMenu: [
          {
            to: '/report-analytics/bulk-messages',
            title: 'Campaign',
            parent: 'Reports',
            Permissions: 'all',
          },
          {
            to: '/report-analytics/landing-page',
            title: 'Landing Page',
            parent: 'Reports',
            Permissions: 'all',
          },
          {
            to: '/report-analytics/short-link',
            title: 'Short Link',
            parent: 'Reports',
            Permissions: 'all',
          },
          {
            to: '/report-analytics/flow',
            title: 'Flow Reports',
            parent: 'Reports',
            Permissions: 'all',
          },
        ],
      },
      {
        to: '/landing-page',
        // icon: '/media/icons/duotune/coding/cod006.svg',
        // fontIcon: '/media/icons/duotune/coding/cod006.svg',
        title: 'Landing Pages',
        Permissions: 'all',
      },
      {
        to: '/templates/template',
        // icon: '/media/icons/duotune/navigationicon/archive.svg',
        // fontIcon: '/media/icons/duotune/navigationicon/archive.svg',
        title: 'Templates',
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/sales',
    icon: '/media/icons/duotune/communication/com014.svg',
    title: 'Sales',
    Permissions: 'all',
    subMenu: [
      {
        to: '/wallet-card',
        // icon: '/media/icons/duotune/general/gen008.svg',
        // fontIcon: '/media/icons/duotune/general/gen008.svg',
        title: 'AI B-Cards',
        parent: 'Sales',
        Permissions: 'all',
        subMenu: [
          {
            to: '/wallet-card',
            title: 'My Cards',
            parent: 'AI B-Cards',
            Permissions: 'all',
          },
          {
            to: '/card-templates',
            title: 'My Templates',
            parent: 'AI B-Cards',
            Permissions: 'all',
          },
          {
            to: '/promo-action',
            title: 'Card Offers',
            parent: 'AI B-Cards',
            Permissions: 'all',
          },
        ],
      },
      {
        to: '/automation',
        // icon: '/media/icons/duotune/navigationicon/data.svg',
        // fontIcon: '/media/icons/duotune/navigationicon/data.svg',
        parent: 'Sales',
        title: 'Flow and Automation',
        Permissions: 'send-quick-sms',
      },
    ],
  },
  {
    to: '/lead-capture',
    icon: '/media/icons/lead-capture-form.svg',
    title: 'Lead Capture',
    Permissions: 'all',
    subMenu: [
      {
        to: '/sales/live-chat',
        // icon: '',
        // fontIcon: 'bi-send',
        title: 'LiveChat',
        parent: 'Lead Capture',
        Permissions: 'all',
        subMenu: [
          {
            to: '#',
            title: 'Conversations',
            parent: 'LiveChat',
            Permissions: 'all',
          },
          {
            to: '#',
            title: 'Settings',
            parent: 'LiveChat',
            Permissions: 'all',
          },
        ],
      },
      {
        to: '/tools/form',
        // icon: '/media/icons/lead-capture-form.svg',
        // fontIcon: '/media/icons/lead-capture-form.svg',
        title: 'Lead Forms',
        parent: 'Lead Capture',
        Permissions: 'all',
      },
      {
        to: '/automation',
        // icon: '/media/icons/duotune/navigationicon/data.svg',
        // fontIcon: '/media/icons/duotune/navigationicon/data.svg',
        title: 'Flow and Automation',
        parent: 'Lead Capture',
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/customer-excellence',
    icon: '/media/icons/duotune/navigationicon/data.svg',
    title: 'Customer Excellence',
    Permissions: 'all',
    subMenu: [
      {
        to: '#',
        // icon: '/media/icons/duotune/communication/com007.svg',
        // fontIcon: '/media/icons/duotune/communication/com007.svg',
        title: 'Quick Message',
        parent: 'Customer Excellence',
        Permissions: 'all',
      },
      {
        to: '#',
        // icon: '/media/icons/duotune/graphs/gra004.svg',
        // fontIcon: '/media/icons/duotune/graphs/gra004.svg',
        title: 'Reviews',
        parent: 'Customer Excellence',
        Permissions: 'all',
      },
      {
        to: '/automation',
        // icon: '/media/icons/duotune/navigationicon/data.svg',
        // fontIcon: '/media/icons/duotune/navigationicon/data.svg',
        title: 'Flow and Automation',
        parent: 'Customer Excellence',
        Permissions: 'all',
      },
      {
        to: '/report-analytics/activity-logs',
        // icon: '/media/icons/duotune/graphs/gra011.svg',
        // fontIcon: '/media/icons/duotune/graphs/gra011.svg',
        title: 'Activity Logs',
        parent: 'Customer Excellence',
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/contacts/subscriber',
    title: 'Contacts',
    icon: '/media/icons/duotune/communication/com005.svg',
    Permissions: 'contacts-list',
  },
]

export const CampaignRegion = [
  ////////////////////////////////FRONTEND USER//////////////////////////////////////////////
  {
    to: '/message',
    icon: '/media/icons/duotune/navigationicon/bulkmsg.svg',
    title: 'Send Message',
    Permissions: 'all',
    subMenu: [
      {
        to: '#',
        icon: '',
        fontIcon: 'bi-send',
        title: 'Quick Message',
        Permissions: 'send-quick-sms',
      },
      {
        to: '/new-message',
        icon: '/media/icons/duotune/navigationicon/bulkmsg.svg',
        title: 'Send Campaign',
        Permissions: 'send-quick-sms',
      },
      // {
      //   to: '/templates/savedCampaign',
      //   title: 'Saved Campaigns',
      //   hasBullet: true,
      //   Permissions: 'segments-list',
      // },
      // {
      //   to: '/file-scheduler',
      //   icon: '/media/icons/duotune/files/fil016.svg',
      //   title: 'File Scheduler',
      //   Permissions: 'send-quick-sms',
      // },
    ],
  },
  {
    to: '/contacts',
    title: 'Contacts',
    icon: '/media/icons/duotune/communication/com005.svg',
    Permissions: 'contacts-list',
    subMenu: [
      {
        to: '/contacts/subscriber',
        title: 'All Contacts',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
      {to: '/contacts/list', title: 'List', hasBullet: true, Permissions: 'tags-list'},
      {to: '/contacts/tags', title: 'Tags', hasBullet: true, Permissions: 'tags-list'},
      // { to: '/contacts/segments', title: 'Segments', hasBullet: true, Permissions: 'segments-list' },
      {
        to: '/contacts/upload-history',
        title: 'Upload History',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
      {
        to: '/contacts/unsubscribe',
        title: 'Unsubscribed',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
    ],
  },
  {
    to: '/report-analytics',
    icon: '/media/icons/duotune/graphs/gra007.svg',
    title: 'Reports & Analytics',
    Permissions: 'all',
    subMenu: [
      {
        to: '/report-analytics/bulk-messages',
        title: 'Campaign reports',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/activity-logs',
        title: 'Activity Log',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/flow',
        title: 'Flow Reports',
        hasBullet: true,
        Permissions: 'all',
      },
      // {
      //   to: '/report-analytics/quick-messages',
      //   title: 'Quick message',
      //   hasBullet: true,
      //   Permissions: 'all',
      // },
    ],
  },
]

export const More = [
  {
    to: '/integration',
    icon: '/media/icons/duotune/navigationicon/cloud.svg',
    title: 'Api and Integrations',
    Permissions: 'all',
    subMenu: [
      {
        to: '/accounts/api-keys',
        title: 'API Setup',
        parent: 'Api and Integrations',
        // icon: '/media/icons/duotune/coding/cod003.svg',
        // fontIcon: '/media/icons/duotune/coding/cod003.svg',
        Permissions: 'all',
      },
      {
        to: '/integration',
        title: 'Integrations',
        parent: 'Api and Integrations',
        // icon: '/media/icons/duotune/navigationicon/cloud.svg',
        // fontIcon: '/media/icons/duotune/navigationicon/cloud.svg',
        Permissions: 'all',
      },
      {
        to: '/email-to-sms',
        title: 'Email to SMS',
        parent: 'Api and Integrations',
        // icon: '/media/icons/duotune/communication/com002.svg',
        // fontIcon: '/media/icons/duotune/communication/com002.svg',
        Permissions: 'all',
      },
      {
        to: '/report-analytics/activity-logs',
        title: 'Activity Logs',
        parent: 'Api and Integrations',
        // icon: '/media/icons/duotune/graphs/gra011.svg',
        // fontIcon: '/media/icons/duotune/graphs/gra011.svg',
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/accounts',
    icon: '',
    fontIcon: 'bi-person',
    title: 'My Account',
    Permissions: 'all',
    subMenu: [
      {
        to: '/topup',
        title: 'Purchase Credit',
        parent: 'My Account',
        // icon: '/media/icons/duotune/finance/fin001.svg',
        // fontIcon: '/media/icons/duotune/finance/fin001.svg',
        Permissions: 'purchase-credits',
      },
      {
        to: '/accounts/referral',
        title: 'Affiliate',
        parent: 'My Account',
        // icon: '/media/icons/duotune/graphs/gra001.svg',
        // fontIcon: '/media/icons/duotune/graphs/gra001.svg',
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/billing?scrollId=auto-fill',
        title: 'Auto Top-up',
        parent: 'My Account',
        // icon: '/media/icons/duotune/finance/fin002.svg',
        // fontIcon: '/media/icons/duotune/finance/fin002.svg',
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/billing?scrollId=purchase-history',
        title: 'Billing',
        parent: 'My Account',
        // icon: '/media/icons/duotune/finance/fin010.svg',
        // fontIcon: '/media/icons/duotune/finance/fin010.svg',
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/team-list',
        title: 'Users',
        parent: 'My Account',
        // icon: '/media/icons/duotune/users/users.svg',
        // fontIcon: '/media/icons/duotune/users/users.svg',
        Permissions: 'list-sub-accounts',
      },
    ],
  },
  {
    to: '/setting',
    icon: '',
    fontIcon: 'bi-gear',
    title: 'Settings',
    Permissions: 'all',
    subMenu: [
      {
        to: '/accounts/notifications',
        title: 'Notification',
        parent: 'Settings',
        // icon: '/media/icons/duotune/communication/com004.svg',
        // fontIcon: '/media/icons/duotune/communication/com004.svg',
        Permissions: 'all',
      },
      {
        to: '/sender-id',
        title: "Sender ID's",
        parent: 'Settings',
        // icon: '/media/icons/duotune/navigationicon/medal_star.svg',
        // fontIcon: '/media/icons/duotune/navigationicon/medal_star.svg',
        Permissions: 'all',
      },
      {
        to: '/accounts/overview',
        title: 'Profile Details',
        parent: 'Settings',
        // icon: '',
        // fontIcon: 'bi-person',
        Permissions: 'all',
      },
      {
        to: '/accounts/settings',
        title: 'Global Settings',
        parent: 'Settings',
        // icon: '/media/icons/duotune/settings/setting.svg',
        // fontIcon: '/media/icons/duotune/settings/setting.svg',
        Permissions: 'all',
      },
    ],
  },
]

export const MoreRegion = [
  {
    to: "/accounts/sender-id's",
    icon: '/media/icons/duotune/navigationicon/medal_star.svg',
    title: "Sender ID's",
    Permissions: 'show-dedicated-number',
  },
  {
    to: "/accounts/sender-id's",
    title: 'Dedicated Numbers',
    icon: '/media/icons/duotune/navigationicon/phone.svg',
    Permissions: 'purchase-dedicated-number',
  },
  {
    to: '/topup',
    title: 'Purchase credit ',
    icon: '/media/icons/duotune/navigationicon/cash.svg',
    Permissions: 'purchase-credits',
  },
  {
    to: '/integration',
    icon: '/media/icons/duotune/navigationicon/cloud.svg',
    title: 'Integrations',
    Permissions: 'all',
  },
  {
    to: '/setting',
    icon: '',
    fontIcon: 'bi-gear',
    title: 'Settings',
    Permissions: 'all',
    subMenu: [
      {
        to: '/email-to-sms',
        hasBullet: true,
        title: 'Email to SMS',
        Permissions: 'all',
      },
      {
        to: '/accounts/api-keys',
        title: 'API Setup',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/accounts/billing?scrollId=purchase-history',
        title: 'Billing History',
        hasBullet: true,
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/balance-history',
        title: 'Credit History',
        hasBullet: true,
        Permissions: 'create-auto-popup-setting',
      },
    ],
  },
]

export const Tools = []

export const WalletCard = []

export const WalletCardNotActivate = []
